import * as React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import clsx from 'clsx'
import zIndex from 'styles/tools/z-index'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useCalendarBurnToggleVisible from 'components/OfferPage/Filters/CalendarPicker/useCalendarBurnToggleVisible'

const MobileStickyHeader = styled.div`
  position: sticky;
  top: 0;
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: ${props => props.theme.shadow.bottom.small};
  z-index: ${zIndex.stickyFooter};

  padding: ${rem(8)} ${rem(16)};

  &.isBurnSliderShown {
    box-shadow: none;
    border-bottom: 1px solid ${props => props.theme.palette.neutral.default.six};
  }

  ${mediaQueryUp.tablet} {
    display: none;
  }
`

interface Props {
  children?: React.ReactNode
}

function AccommodationOfferPageStickyHeaderMobile({ children }: Props) {
  const isBurnSliderShown = useCalendarBurnToggleVisible()
  return (
    <MobileStickyHeader className={clsx({ isBurnSliderShown })}>
      {children}
    </MobileStickyHeader>
  )
}

export default AccommodationOfferPageStickyHeaderMobile
